import { render, staticRenderFns } from "./NewCost.vue?vue&type=template&id=84030258&scoped=true&"
import script from "./NewCost.vue?vue&type=script&lang=js&"
export * from "./NewCost.vue?vue&type=script&lang=js&"
import style0 from "./NewCost.vue?vue&type=style&index=0&id=84030258&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84030258",
  null
  
)

export default component.exports